__turbopack_context__.v({
  "errorWrapper": "styles-module-scss-module__vvDfPq__errorWrapper",
});
